
export declare type Type = 'default' | 'block';

export const FileType = {
  image: ['png', 'jpg', 'jpeg'],
  file: [
    'doc',
    'docx',
    'xls',
    'xlsx',
    'ppt',
    'pptx',
    'pdf',
    'zip',
    'tar',
    'rar'
  ],
  document: ['doc', 'docx', 'pdf'],
  sheet: ['xls', 'xlsx'],
};

export function getExt(fileName: string) {
  if (!fileName) {
    return 'common-type';
  }
  if (fileName.split('.').length === 1) {
      return 'folder-f';
  }
  const ext = fileName.split('.')[fileName.split('.').length - 1];
  if (ext === 'pdf') {
    return 'pdf';
  }
  if (ext === 'zip' || ext === 'tar' || ext === 'rar') {
    return 'zip';
  }
  if (ext === 'xls' || ext === 'xlsx') {
    return 'xls';
  }
  if (ext === 'ppt' || ext === 'pptx') {
    return 'ppt';
  }
  if (ext === 'doc' || ext === 'docx') {
    return 'word';
  }
  if (FileType.image.indexOf(ext) >= 0) {
    return 'pic';
  }
  
  return 'common-type';
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/ABSFileTypeText/util.ts